/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_Same_As_RoundInputs */



/**
* | output |
* | --- |
* | "Same as round" |
*
* @param {Timer_Same_As_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const timer_same_as_round = /** @type {((inputs?: Timer_Same_As_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_Same_As_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Identique à la ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Igual que la ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Igual à rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Uguale al round")
	return /** @type {LocalizedString} */ ("Same as round")
});